 const regions = [
  // {
  //   REGION: 3,
  //   REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 24,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 1,
  //       LOCAL_REGION_NAME: 'АНДИЖОН ШАХРИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АНДИЖОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'АНДИЖОН ШАХРИ'
  //     },
  //     {
  //       id: 26,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 3,
  //       LOCAL_REGION_NAME: 'ХОНОБОД ШАХРИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХОНОБОД ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ХОНОБОД ШАХРИ'
  //     },
  //     {
  //       id: 27,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 4,
  //       LOCAL_REGION_NAME: 'КОРАСУВ ШАХРИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОРАСУВ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'КОРАСУВ ШАХРИ'
  //     },
  //     {
  //       id: 28,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 5,
  //       LOCAL_REGION_NAME: 'Г.ШАХРИХАН',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'Г.ШАХРИХАН',
  //       LOCAL_REGION_NAMER: 'Г.ШАХРИХАН'
  //     },
  //     {
  //       id: 29,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 6,
  //       LOCAL_REGION_NAME: 'АНДИЖОН ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АНДИЖОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'АНДИЖОН ТУМАНИ'
  //     },
  //     {
  //       id: 30,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 7,
  //       LOCAL_REGION_NAME: 'АСАКА ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АСАКА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'АСАКА ТУМАНИ'
  //     },
  //     {
  //       id: 31,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 8,
  //       LOCAL_REGION_NAME: 'БАЛИКЧИ ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БАЛИКЧИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БАЛИКЧИ ТУМАНИ'
  //     },
  //     {
  //       id: 32,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 9,
  //       LOCAL_REGION_NAME: 'БУЗ ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУЗ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУЗ ТУМАНИ'
  //     },
  //     {
  //       id: 33,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 10,
  //       LOCAL_REGION_NAME: 'БУЛОКБОШИ ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУЛОКБОШИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУЛОКБОШИ ТУМАНИ'
  //     },
  //     {
  //       id: 34,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 11,
  //       LOCAL_REGION_NAME: 'ЖАЛОЛКУДУК ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЖАЛОЛКУДУК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЖАЛОЛКУДУК ТУМАНИ'
  //     },
  //     {
  //       id: 35,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 12,
  //       LOCAL_REGION_NAME: 'ИЗБОСКАН ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ИЗБОСКАН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ИЗБОСКАН ТУМАНИ'
  //     },
  //     {
  //       id: 36,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 13,
  //       LOCAL_REGION_NAME: 'КОМСОМОЛАБАДСКИЙ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОМСОМОЛАБАДСКИЙ',
  //       LOCAL_REGION_NAMER: 'КОМСОМОЛАБАДСКИЙ'
  //     },
  //     {
  //       id: 37,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 15,
  //       LOCAL_REGION_NAME: 'МАРХАМАТ ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МАРХАМАТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МАРХАМАТ ТУМАНИ'
  //     },
  //     {
  //       id: 38,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 18,
  //       LOCAL_REGION_NAME: 'ХУЖАОБОД ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХУЖАОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХУЖАОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 25,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 2,
  //       LOCAL_REGION_NAME: 'АСАКА ШАХРИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АСАКА ШАХРИ',
  //       LOCAL_REGION_NAMER: 'АСАКА ШАХРИ'
  //     },
  //     {
  //       id: 140,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 214,
  //       LOCAL_REGION_NAME: 'ШАХРИХОН ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШАХРИХОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШАХРИХОН ТУМАНИ'
  //     },
  //     {
  //       id: 136,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 14,
  //       LOCAL_REGION_NAME: 'КУРГОНТЕПА ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУРГОНТЕПА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУРГОНТЕПА ТУМАНИ'
  //     },
  //     {
  //       id: 137,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 16,
  //       LOCAL_REGION_NAME: 'ОЛТИНКУЛ ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОЛТИНКУЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОЛТИНКУЛ ТУМАНИ'
  //     },
  //     {
  //       id: 138,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 17,
  //       LOCAL_REGION_NAME: 'ПАХТАОБОД ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПАХТАОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПАХТАОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 139,
  //       REGION: 3,
  //       REGION_NAME: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION: 210,
  //       LOCAL_REGION_NAME: 'УЛУГНОР ТУМАНИ',
  //       REGION_PLACE: 2,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'АНДИЖОН ВИЛОЯТИ',
  //       REGION_NAMER: 'АНДИЖОН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЛУГНОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЛУГНОР ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 6,
  //   REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 39,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 19,
  //       LOCAL_REGION_NAME: 'ОЛОТ ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОЛОТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОЛОТ ТУМАНИ'
  //     },
  //     {
  //       id: 40,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 21,
  //       LOCAL_REGION_NAME: 'ГИЖДУВОН ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГИЖДУВОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ГИЖДУВОН ТУМАНИ'
  //     },
  //     {
  //       id: 41,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 24,
  //       LOCAL_REGION_NAME: 'РОМИТАН ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'РОМИТАН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'РОМИТАН ТУМАНИ'
  //     },
  //     {
  //       id: 42,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 27,
  //       LOCAL_REGION_NAME: 'ПЕШКУ ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПЕШКУ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПЕШКУ ТУМАНИ'
  //     },
  //     {
  //       id: 43,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 29,
  //       LOCAL_REGION_NAME: 'КОГОН ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОГОН ТУМАНИ'
  //     },
  //     {
  //       id: 141,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 20,
  //       LOCAL_REGION_NAME: 'ВОБКЕНТ ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ВОБКЕНТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ВОБКЕНТ ТУМАНИ'
  //     },
  //     {
  //       id: 148,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 220,
  //       LOCAL_REGION_NAME: 'КОГОН ШАХРИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОГОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'КОГОН ШАХРИ'
  //     },
  //     {
  //       id: 143,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 23,
  //       LOCAL_REGION_NAME: 'КОРАКУЛ ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОРАКУЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОРАКУЛ ТУМАНИ'
  //     },
  //     {
  //       id: 144,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 25,
  //       LOCAL_REGION_NAME: 'ЖОНДОР ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЖОНДОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЖОНДОР ТУМАНИ'
  //     },
  //     {
  //       id: 145,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 26,
  //       LOCAL_REGION_NAME: 'ШОФИРКОН ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШОФИРКОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШОФИРКОН ТУМАНИ'
  //     },
  //     {
  //       id: 146,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 28,
  //       LOCAL_REGION_NAME: 'КОРОВУЛБОЗОР ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОРОВУЛБОЗОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОРОВУЛБОЗОР ТУМАНИ'
  //     },
  //     {
  //       id: 147,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 30,
  //       LOCAL_REGION_NAME: 'БУХОРО ШАХРИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУХОРО ШАХРИ',
  //       LOCAL_REGION_NAMER: 'БУХОРО ШАХРИ'
  //     },
  //     {
  //       id: 142,
  //       REGION: 6,
  //       REGION_NAME: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION: 22,
  //       LOCAL_REGION_NAME: 'БУХОРО ТУМАНИ',
  //       REGION_PLACE: 3,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'БУХОРО ВИЛОЯТИ',
  //       REGION_NAMER: 'БУХОРО ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУХОРО ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУХОРО ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 8,
  //   REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 20,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 217,
  //       LOCAL_REGION_NAME: 'ЯНГИОБОД ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 44,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 31,
  //       LOCAL_REGION_NAME: 'ЖИЗЗАХ ШАХРИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЖИЗЗАХ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ЖИЗЗАХ ШАХРИ'
  //     },
  //     {
  //       id: 45,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 34,
  //       LOCAL_REGION_NAME: 'ДУСТЛИК ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ДУСТЛИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ДУСТЛИК ТУМАНИ'
  //     },
  //     {
  //       id: 46,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 37,
  //       LOCAL_REGION_NAME: 'БАХМАЛ ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БАХМАЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БАХМАЛ ТУМАНИ'
  //     },
  //     {
  //       id: 47,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 40,
  //       LOCAL_REGION_NAME: 'ШАРОФ РАШИДОВ ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШАРОФ РАШИДОВ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШАРОФ РАШИДОВ ТУМАНИ'
  //     },
  //     {
  //       id: 149,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 32,
  //       LOCAL_REGION_NAME: 'ПАХТАКОР ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПАХТАКОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПАХТАКОР ТУМАНИ'
  //     },
  //     {
  //       id: 156,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 42,
  //       LOCAL_REGION_NAME: 'ЗАРБДОР ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЗАРБДОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЗАРБДОР ТУМАНИ'
  //     },
  //     {
  //       id: 151,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 35,
  //       LOCAL_REGION_NAME: 'МИРЗАЧУЛ ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МИРЗАЧУЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МИРЗАЧУЛ ТУМАНИ'
  //     },
  //     {
  //       id: 152,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 36,
  //       LOCAL_REGION_NAME: 'ЗОМИН ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЗОМИН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЗОМИН ТУМАНИ'
  //     },
  //     {
  //       id: 153,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 38,
  //       LOCAL_REGION_NAME: 'ФОРИШ ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ФОРИШ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ФОРИШ ТУМАНИ'
  //     },
  //     {
  //       id: 154,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 39,
  //       LOCAL_REGION_NAME: 'ЗАФАРОБОД ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЗАФАРОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЗАФАРОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 155,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 41,
  //       LOCAL_REGION_NAME: 'АРНАСОЙ ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АРНАСОЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'АРНАСОЙ ТУМАНИ'
  //     },
  //     {
  //       id: 150,
  //       REGION: 8,
  //       REGION_NAME: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION: 33,
  //       LOCAL_REGION_NAME: 'ГАЛЛАОРОЛ ТУМАНИ',
  //       REGION_PLACE: 4,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       REGION_NAMER: 'ЖИЗЗАХ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГАЛЛАОРОЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ГАЛЛАОРОЛ ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 10,
  //   REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 52,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 56,
  //       LOCAL_REGION_NAME: 'МУБОРАК ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МУБОРАК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МУБОРАК ТУМАНИ'
  //     },
  //     {
  //       id: 51,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 53,
  //       LOCAL_REGION_NAME: 'КАСБИ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАСБИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КАСБИ ТУМАНИ'
  //     },
  //     {
  //       id: 50,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 50,
  //       LOCAL_REGION_NAME: 'ЧИРОКЧИ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЧИРОКЧИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЧИРОКЧИ ТУМАНИ'
  //     },
  //     {
  //       id: 49,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 47,
  //       LOCAL_REGION_NAME: 'КАМАШИ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАМАШИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КАМАШИ ТУМАНИ'
  //     },
  //     {
  //       id: 48,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 45,
  //       LOCAL_REGION_NAME: 'ГУЗОР ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГУЗОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ГУЗОР ТУМАНИ'
  //     },
  //     {
  //       id: 22,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 221,
  //       LOCAL_REGION_NAME: 'МИРИШКОР ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МИРИШКОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МИРИШКОР ТУМАНИ'
  //     },
  //     {
  //       id: 229,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 228,
  //       LOCAL_REGION_NAME: 'КУКДАЛА ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУКДАЛА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУКДАЛА ТУМАНИ'
  //     },
  //     {
  //       id: 163,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 52,
  //       LOCAL_REGION_NAME: 'КИТОБ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КИТОБ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КИТОБ ТУМАНИ'
  //     },
  //     {
  //       id: 164,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 54,
  //       LOCAL_REGION_NAME: 'НИШОН ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НИШОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НИШОН ТУМАНИ'
  //     },
  //     {
  //       id: 161,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 49,
  //       LOCAL_REGION_NAME: 'ШАХРИСАБЗ ШАХРИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШАХРИСАБЗ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ШАХРИСАБЗ ШАХРИ'
  //     },
  //     {
  //       id: 160,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 48,
  //       LOCAL_REGION_NAME: 'КОСОН ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОСОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОСОН ТУМАНИ'
  //     },
  //     {
  //       id: 159,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 46,
  //       LOCAL_REGION_NAME: 'ДЕХКОНОБОД ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ДЕХКОНОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ДЕХКОНОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 158,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 44,
  //       LOCAL_REGION_NAME: 'КАРШИ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАРШИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КАРШИ ТУМАНИ'
  //     },
  //     {
  //       id: 157,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 43,
  //       LOCAL_REGION_NAME: 'КАРШИ ШАХРИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАРШИ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'КАРШИ ШАХРИ'
  //     },
  //     {
  //       id: 167,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 213,
  //       LOCAL_REGION_NAME: 'ШАХРИСАБЗ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШАХРИСАБЗ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШАХРИСАБЗ ТУМАНИ'
  //     },
  //     {
  //       id: 166,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 57,
  //       LOCAL_REGION_NAME: 'БАХОРИСТАНСКИЙ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БАХОРИСТАНСКИЙ',
  //       LOCAL_REGION_NAMER: 'БАХОРИСТАНСКИЙ'
  //     },
  //     {
  //       id: 165,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 55,
  //       LOCAL_REGION_NAME: 'У.ЮСУПОВСКИЙ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'У.ЮСУПОВСКИЙ',
  //       LOCAL_REGION_NAMER: 'У.ЮСУПОВСКИЙ'
  //     },
  //     {
  //       id: 162,
  //       REGION: 10,
  //       REGION_NAME: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 51,
  //       LOCAL_REGION_NAME: 'ЯККАБОГ ТУМАНИ',
  //       REGION_PLACE: 5,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'КАШКАДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯККАБОГ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЯККАБОГ ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 12,
  //   REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 53,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 60,
  //       LOCAL_REGION_NAME: 'Г.УЧКУДУК',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'Г.УЧКУДУК',
  //       LOCAL_REGION_NAMER: 'Г.УЧКУДУК'
  //     },
  //     {
  //       id: 54,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 62,
  //       LOCAL_REGION_NAME: 'КОНИМЕХ ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОНИМЕХ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОНИМЕХ ТУМАНИ'
  //     },
  //     {
  //       id: 55,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 65,
  //       LOCAL_REGION_NAME: 'НУРОТА ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НУРОТА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НУРОТА ТУМАНИ'
  //     },
  //     {
  //       id: 56,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 67,
  //       LOCAL_REGION_NAME: 'ТОМДИ ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТОМДИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТОМДИ ТУМАНИ'
  //     },
  //     {
  //       id: 134,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 224,
  //       LOCAL_REGION_NAME: 'ГОЗГОН ШАХРИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'Навоийская область',
  //       LOCAL_REGION_NAMEU: 'ГОЗГОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ГОЗГОН ШАХРИ'
  //     },
  //     {
  //       id: 174,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 211,
  //       LOCAL_REGION_NAME: 'УЧКУДУК ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЧКУДУК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЧКУДУК ТУМАНИ'
  //     },
  //     {
  //       id: 169,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 59,
  //       LOCAL_REGION_NAME: 'ЗАРАФШОН ШАХРИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЗАРАФШОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ЗАРАФШОН ШАХРИ'
  //     },
  //     {
  //       id: 170,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 61,
  //       LOCAL_REGION_NAME: 'КАРМАНА ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАРМАНА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КАРМАНА ТУМАНИ'
  //     },
  //     {
  //       id: 171,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 63,
  //       LOCAL_REGION_NAME: 'КИЗИЛТЕПА ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КИЗИЛТЕПА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КИЗИЛТЕПА ТУМАНИ'
  //     },
  //     {
  //       id: 172,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 64,
  //       LOCAL_REGION_NAME: 'НАВБАХОР ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НАВБАХОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НАВБАХОР ТУМАНИ'
  //     },
  //     {
  //       id: 173,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 66,
  //       LOCAL_REGION_NAME: 'ХАТИРЧИ ТУМАНИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХАТИРЧИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХАТИРЧИ ТУМАНИ'
  //     },
  //     {
  //       id: 168,
  //       REGION: 12,
  //       REGION_NAME: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION: 58,
  //       LOCAL_REGION_NAME: 'НАВОИЙ ШАХРИ',
  //       REGION_PLACE: 6,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАВОИЙ ВИЛОЯТИ',
  //       REGION_NAMER: 'НАВОИЙ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НАВОИЙ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'НАВОИЙ ШАХРИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 14,
  //   REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 57,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 69,
  //       LOCAL_REGION_NAME: 'МИНГБУЛОК ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МИНГБУЛОК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МИНГБУЛОК ТУМАНИ'
  //     },
  //     {
  //       id: 58,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 72,
  //       LOCAL_REGION_NAME: 'ПОП ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПОП ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПОП ТУМАНИ'
  //     },
  //     {
  //       id: 59,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 75,
  //       LOCAL_REGION_NAME: 'УЧКУРГОН ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЧКУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЧКУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 60,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 78,
  //       LOCAL_REGION_NAME: 'НАМАНГАН ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НАМАНГАН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НАМАНГАН ТУМАНИ'
  //     },
  //     {
  //       id: 175,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 68,
  //       LOCAL_REGION_NAME: 'НАМАНГАН ШАХРИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НАМАНГАН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'НАМАНГАН ШАХРИ'
  //     },
  //     {
  //       id: 176,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 70,
  //       LOCAL_REGION_NAME: 'КОСОНСОЙ ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КОСОНСОЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОСОНСОЙ ТУМАНИ'
  //     },
  //     {
  //       id: 177,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 71,
  //       LOCAL_REGION_NAME: 'НОРИН ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НОРИН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НОРИН ТУМАНИ'
  //     },
  //     {
  //       id: 178,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 73,
  //       LOCAL_REGION_NAME: 'ТУРАКУРГОН ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТУРАКУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТУРАКУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 179,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 74,
  //       LOCAL_REGION_NAME: 'УЙЧИ ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЙЧИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЙЧИ ТУМАНИ'
  //     },
  //     {
  //       id: 180,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 76,
  //       LOCAL_REGION_NAME: 'ЧУСТ ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЧУСТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЧУСТ ТУМАНИ'
  //     },
  //     {
  //       id: 181,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 77,
  //       LOCAL_REGION_NAME: 'ЯНГИКУРГОН ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИКУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИКУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 182,
  //       REGION: 14,
  //       REGION_NAME: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION: 79,
  //       LOCAL_REGION_NAME: 'ЧОРТОК ТУМАНИ',
  //       REGION_PLACE: 7,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'НАМАНГАН ВИЛОЯТИ',
  //       REGION_NAMER: 'НАМАНГАН ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЧОРТОК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЧОРТОК ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 18,
  //   REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 21,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 218,
  //       LOCAL_REGION_NAME: 'Г.АКТАШ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'Г.АКТАШ',
  //       LOCAL_REGION_NAMER: 'Г.АКТАШ'
  //     },
  //     {
  //       id: 62,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 84,
  //       LOCAL_REGION_NAME: 'ИШТИХОН ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ИШТИХОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ИШТИХОН ТУМАНИ'
  //     },
  //     {
  //       id: 63,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 86,
  //       LOCAL_REGION_NAME: 'КУШРАБОТ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУШРАБОТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУШРАБОТ ТУМАНИ'
  //     },
  //     {
  //       id: 64,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 88,
  //       LOCAL_REGION_NAME: 'НУРОБОД ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НУРОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НУРОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 65,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 89,
  //       LOCAL_REGION_NAME: 'ПАСТДАРГОМ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПАСТДАРГОМ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПАСТДАРГОМ ТУМАНИ'
  //     },
  //     {
  //       id: 66,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 90,
  //       LOCAL_REGION_NAME: 'ПАХТАЧИ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПАХТАЧИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПАХТАЧИ ТУМАНИ'
  //     },
  //     {
  //       id: 67,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 91,
  //       LOCAL_REGION_NAME: 'ПАЙАРИК ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПАЙАРИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПАЙАРИК ТУМАНИ'
  //     },
  //     {
  //       id: 68,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 92,
  //       LOCAL_REGION_NAME: 'САМАРКАНД ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'САМАРКАНД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'САМАРКАНД ТУМАНИ'
  //     },
  //     {
  //       id: 69,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 93,
  //       LOCAL_REGION_NAME: 'ТАЙЛОК ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТАЙЛОК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТАЙЛОК ТУМАНИ'
  //     },
  //     {
  //       id: 70,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 94,
  //       LOCAL_REGION_NAME: 'УРГУТ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УРГУТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УРГУТ ТУМАНИ'
  //     },
  //     {
  //       id: 71,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 95,
  //       LOCAL_REGION_NAME: 'ЧЕЛЕКСКИЙ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЧЕЛЕКСКИЙ',
  //       LOCAL_REGION_NAMER: 'ЧЕЛЕКСКИЙ'
  //     },
  //     {
  //       id: 72,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 96,
  //       LOCAL_REGION_NAME: 'САМАРКАНД ШАХРИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'САМАРКАНД ШАХРИ',
  //       LOCAL_REGION_NAMER: 'САМАРКАНД ШАХРИ'
  //     },
  //     {
  //       id: 73,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 97,
  //       LOCAL_REGION_NAME: 'КАТТАКУРГОН ШАХРИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАТТАКУРГОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'КАТТАКУРГОН ШАХРИ'
  //     },
  //     {
  //       id: 61,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 81,
  //       LOCAL_REGION_NAME: 'БУЛУНГУР ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУЛУНГУР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУЛУНГУР ТУМАНИ'
  //     },
  //     {
  //       id: 189,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 219,
  //       LOCAL_REGION_NAME: 'Г.УРГУТ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'Г.УРГУТ',
  //       LOCAL_REGION_NAMER: 'Г.УРГУТ'
  //     },
  //     {
  //       id: 188,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 215,
  //       LOCAL_REGION_NAME: 'ТЕМИРЮЛЬСКИЙ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТЕМИРЮЛЬСКИЙ',
  //       LOCAL_REGION_NAMER: 'ТЕМИРЮЛЬСКИЙ'
  //     },
  //     {
  //       id: 187,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 87,
  //       LOCAL_REGION_NAME: 'НАРПАЙ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НАРПАЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НАРПАЙ ТУМАНИ'
  //     },
  //     {
  //       id: 186,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 85,
  //       LOCAL_REGION_NAME: 'КАТТАКУРГОН ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КАТТАКУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КАТТАКУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 185,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 83,
  //       LOCAL_REGION_NAME: 'ЖОМБОЙ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЖОМБОЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЖОМБОЙ ТУМАНИ'
  //     },
  //     {
  //       id: 184,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 82,
  //       LOCAL_REGION_NAME: 'ГУЗАЛКЕНТСКИЙ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГУЗАЛКЕНТСКИЙ',
  //       LOCAL_REGION_NAMER: 'ГУЗАЛКЕНТСКИЙ'
  //     },
  //     {
  //       id: 183,
  //       REGION: 18,
  //       REGION_NAME: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION: 80,
  //       LOCAL_REGION_NAME: 'ОКДАРЁ ТУМАНИ',
  //       REGION_PLACE: 8,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'САМАРКАНД ВИЛОЯТИ',
  //       REGION_NAMER: 'САМАРКАНД ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОКДАРЁ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОКДАРЁ ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 22,
  //   REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 75,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 99,
  //       LOCAL_REGION_NAME: 'БОЙСУН ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БОЙСУН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БОЙСУН ТУМАНИ'
  //     },
  //     {
  //       id: 76,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 100,
  //       LOCAL_REGION_NAME: 'ДЕНОВ ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ДЕНОВ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ДЕНОВ ТУМАНИ'
  //     },
  //     {
  //       id: 77,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 101,
  //       LOCAL_REGION_NAME: 'ЖАРКУРГОН ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЖАРКУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЖАРКУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 78,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 102,
  //       LOCAL_REGION_NAME: 'МУЗРАБОТ ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МУЗРАБОТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МУЗРАБОТ ТУМАНИ'
  //     },
  //     {
  //       id: 79,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 103,
  //       LOCAL_REGION_NAME: 'ШЕРОБОД ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШЕРОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШЕРОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 80,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 104,
  //       LOCAL_REGION_NAME: 'ШУРЧИ ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШУРЧИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШУРЧИ ТУМАНИ'
  //     },
  //     {
  //       id: 88,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 112,
  //       LOCAL_REGION_NAME: 'БАНДИХОН ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БАНДИХОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БАНДИХОН ТУМАНИ'
  //     },
  //     {
  //       id: 87,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 111,
  //       LOCAL_REGION_NAME: 'ОЛТИНСОЙ ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОЛТИНСОЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОЛТИНСОЙ ТУМАНИ'
  //     },
  //     {
  //       id: 86,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 110,
  //       LOCAL_REGION_NAME: 'ТЕРМИЗ ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТЕРМИЗ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТЕРМИЗ ТУМАНИ'
  //     },
  //     {
  //       id: 85,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 109,
  //       LOCAL_REGION_NAME: 'КУМКУРГОН ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУМКУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУМКУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 84,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 108,
  //       LOCAL_REGION_NAME: 'КИЗИРИК ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КИЗИРИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КИЗИРИК ТУМАНИ'
  //     },
  //     {
  //       id: 83,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 107,
  //       LOCAL_REGION_NAME: 'АНГОР ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АНГОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'АНГОР ТУМАНИ'
  //     },
  //     {
  //       id: 74,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 98,
  //       LOCAL_REGION_NAME: 'ТЕРМИЗ ШАХРИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТЕРМИЗ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ТЕРМИЗ ШАХРИ'
  //     },
  //     {
  //       id: 81,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 105,
  //       LOCAL_REGION_NAME: 'УЗУН ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЗУН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЗУН ТУМАНИ'
  //     },
  //     {
  //       id: 82,
  //       REGION: 22,
  //       REGION_NAME: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 106,
  //       LOCAL_REGION_NAME: 'САРИОСИЁ ТУМАНИ',
  //       REGION_PLACE: 9,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СУРХОНДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'САРИОСИЁ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'САРИОСИЁ ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 24,
  //   REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 94,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 118,
  //       LOCAL_REGION_NAME: 'ОКОЛТИН ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОКОЛТИН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОКОЛТИН ТУМАНИ'
  //     },
  //     {
  //       id: 93,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 117,
  //       LOCAL_REGION_NAME: 'Г.СЫРДАРЬЯ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'Г.СЫРДАРЬЯ',
  //       LOCAL_REGION_NAMER: 'Г.СЫРДАРЬЯ'
  //     },
  //     {
  //       id: 92,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 116,
  //       LOCAL_REGION_NAME: 'ШИРИН ШАХРИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШИРИН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ШИРИН ШАХРИ'
  //     },
  //     {
  //       id: 91,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 115,
  //       LOCAL_REGION_NAME: 'ЯНГИЕР ШАХРИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИЕР ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИЕР ШАХРИ'
  //     },
  //     {
  //       id: 90,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 114,
  //       LOCAL_REGION_NAME: 'ГУЛИСТОН ШАХРИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГУЛИСТОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ГУЛИСТОН ШАХРИ'
  //     },
  //     {
  //       id: 89,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 113,
  //       LOCAL_REGION_NAME: 'Г.БАХТ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'Г.БАХТ',
  //       LOCAL_REGION_NAMER: 'Г.БАХТ'
  //     },
  //     {
  //       id: 95,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 119,
  //       LOCAL_REGION_NAME: 'БОЁВУТ ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БОЁВУТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БОЁВУТ ТУМАНИ'
  //     },
  //     {
  //       id: 99,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 123,
  //       LOCAL_REGION_NAME: 'САЙХУНОБОД ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'САЙХУНОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'САЙХУНОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 98,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 122,
  //       LOCAL_REGION_NAME: 'СИРДАРЁ ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'СИРДАРЁ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'СИРДАРЁ ТУМАНИ'
  //     },
  //     {
  //       id: 97,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 121,
  //       LOCAL_REGION_NAME: 'САРДОБА ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'САРДОБА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'САРДОБА ТУМАНИ'
  //     },
  //     {
  //       id: 96,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 120,
  //       LOCAL_REGION_NAME: 'ГУЛИСТОН ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГУЛИСТОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ГУЛИСТОН ТУМАНИ'
  //     },
  //     {
  //       id: 101,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 125,
  //       LOCAL_REGION_NAME: 'МЕХНАТАБАДСКИЙ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МЕХНАТАБАДСКИЙ',
  //       LOCAL_REGION_NAMER: 'МЕХНАТАБАДСКИЙ'
  //     },
  //     {
  //       id: 100,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 124,
  //       LOCAL_REGION_NAME: 'ХАВАСТ ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХАВАСТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХАВАСТ ТУМАНИ'
  //     },
  //     {
  //       id: 102,
  //       REGION: 24,
  //       REGION_NAME: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION: 126,
  //       LOCAL_REGION_NAME: 'МИРЗАОБОД ТУМАНИ',
  //       REGION_PLACE: 10,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'СИРДАРЁ ВИЛОЯТИ',
  //       REGION_NAMER: 'СИРДАРЁ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МИРЗАОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МИРЗАОБОД ТУМАНИ'
  //     }
  //   ]
  // },
  {
    REGION: 26,
    REGION_NAME: 'ТОШКЕНТ ШАХРИ',
    SUB_REGIONS: [
      {
        id: 15,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 198,
        LOCAL_REGION_NAME: 'УЧТЕПА ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'УЧТЕПА ТУМАНИ',
        LOCAL_REGION_NAMER: 'УЧТЕПА ТУМАНИ'
      },
      {
        id: 18,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 206,
        LOCAL_REGION_NAME: 'ЯККАСАРОЙ ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ЯККАСАРОЙ ТУМАНИ',
        LOCAL_REGION_NAMER: 'ЯККАСАРОЙ ТУМАНИ'
      },
      {
        id: 17,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 203,
        LOCAL_REGION_NAME: 'ШАЙХОНТОХУР ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ШАЙХОНТОХУР ТУМАНИ',
        LOCAL_REGION_NAMER: 'ШАЙХОНТОХУР ТУМАНИ'
      },
      {
        id: 16,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 200,
        LOCAL_REGION_NAME: 'ЮНУСОБОД ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ЮНУСОБОД ТУМАНИ',
        LOCAL_REGION_NAMER: 'ЮНУСОБОД ТУМАНИ'
      },
      {
        id: 228,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 227,
        LOCAL_REGION_NAME: 'ЯНГИХАЁТ ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ЯНГИХАЁТ ТУМАНИ',
        LOCAL_REGION_NAMER: 'ЯНГИХАЁТ ТУМАНИ'
      },
      {
        id: 194,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 204,
        LOCAL_REGION_NAME: 'ОЛМАЗОР ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ОЛМАЗОР ТУМАНИ',
        LOCAL_REGION_NAMER: 'ОЛМАЗОР ТУМАНИ'
      },
      {
        id: 193,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 202,
        LOCAL_REGION_NAME: 'МИРОБОД ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'МИРОБОД ТУМАНИ',
        LOCAL_REGION_NAMER: 'МИРОБОД ТУМАНИ'
      },
      {
        id: 192,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 201,
        LOCAL_REGION_NAME: 'МИРЗО УЛУГБЕК ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'МИРЗО УЛУГБЕК ТУМАНИ',
        LOCAL_REGION_NAMER: 'МИРЗО УЛУГБЕК ТУМАНИ'
      },
      {
        id: 191,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 199,
        LOCAL_REGION_NAME: 'БЕКТЕМИР ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'БЕКТЕМИР ТУМАНИ',
        LOCAL_REGION_NAMER: 'БЕКТЕМИР ТУМАНИ'
      },
      {
        id: 190,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 197,
        LOCAL_REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMER: 'ТОШКЕНТ ШАХРИ'
      },
      {
        id: 196,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 207,
        LOCAL_REGION_NAME: 'ЯШНОБОД ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ЯШНОБОД ТУМАНИ',
        LOCAL_REGION_NAMER: 'ЯШНОБОД ТУМАНИ'
      },
      {
        id: 195,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 205,
        LOCAL_REGION_NAME: 'СИРГАЛИ ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'СИРГАЛИ ТУМАНИ',
        LOCAL_REGION_NAMER: 'СИРГАЛИ ТУМАНИ'
      },
      {
        id: 197,
        REGION: 26,
        REGION_NAME: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION: 208,
        LOCAL_REGION_NAME: 'ЧИЛОНЗОР ТУМАНИ',
        REGION_PLACE: 11,
        LOCAL_REGION_PLACE: '',
        REGION_NAMEU: 'ТОШКЕНТ ШАХРИ',
        REGION_NAMER: 'ТОШКЕНТ ШАХРИ',
        LOCAL_REGION_NAMEU: 'ЧИЛОНЗОР ТУМАНИ',
        LOCAL_REGION_NAMER: 'ЧИЛОНЗОР ТУМАНИ'
      }
    ]
  },
  // {
  //   REGION: 27,
  //   REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 227,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 223,
  //       LOCAL_REGION_NAME: 'НУРАФШОН ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'НУРАФШОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'НУРАФШОН ШАХРИ'
  //     },
  //     {
  //       id: 116,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 140,
  //       LOCAL_REGION_NAME: 'КУЙИЧИРЧИК ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУЙИЧИРЧИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУЙИЧИРЧИК ТУМАНИ'
  //     },
  //     {
  //       id: 123,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 147,
  //       LOCAL_REGION_NAME: 'ЯНГИЙУЛ ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИЙУЛ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИЙУЛ ШАХРИ'
  //     },
  //     {
  //       id: 122,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 146,
  //       LOCAL_REGION_NAME: 'ЯНГИЙУЛ ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИЙУЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИЙУЛ ТУМАНИ'
  //     },
  //     {
  //       id: 121,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 145,
  //       LOCAL_REGION_NAME: 'ЮКОРИЧИРЧИК ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЮКОРИЧИРЧИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЮКОРИЧИРЧИК ТУМАНИ'
  //     },
  //     {
  //       id: 120,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 144,
  //       LOCAL_REGION_NAME: 'ЧИНОЗ ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЧИНОЗ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЧИНОЗ ТУМАНИ'
  //     },
  //     {
  //       id: 119,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 143,
  //       LOCAL_REGION_NAME: 'УРТАЧИРЧИК ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УРТАЧИРЧИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УРТАЧИРЧИК ТУМАНИ'
  //     },
  //     {
  //       id: 118,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 142,
  //       LOCAL_REGION_NAME: 'ТОШКЕНТ ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТОШКЕНТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТОШКЕНТ ТУМАНИ'
  //     },
  //     {
  //       id: 117,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 141,
  //       LOCAL_REGION_NAME: 'ПСКЕНТ ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПСКЕНТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПСКЕНТ ТУМАНИ'
  //     },
  //     {
  //       id: 115,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 139,
  //       LOCAL_REGION_NAME: 'ПАРКЕНТ ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПАРКЕНТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ПАРКЕНТ ТУМАНИ'
  //     },
  //     {
  //       id: 114,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 138,
  //       LOCAL_REGION_NAME: 'КИБРАЙ ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КИБРАЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КИБРАЙ ТУМАНИ'
  //     },
  //     {
  //       id: 113,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 137,
  //       LOCAL_REGION_NAME: 'БЕКОБОД ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БЕКОБОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БЕКОБОД ТУМАНИ'
  //     },
  //     {
  //       id: 112,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 136,
  //       LOCAL_REGION_NAME: 'ЗАНГИОТА ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЗАНГИОТА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЗАНГИОТА ТУМАНИ'
  //     },
  //     {
  //       id: 103,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 127,
  //       LOCAL_REGION_NAME: 'ОХАНГАРОН ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОХАНГАРОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ОХАНГАРОН ШАХРИ'
  //     },
  //     {
  //       id: 104,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 128,
  //       LOCAL_REGION_NAME: 'ОЛМАЛИК ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОЛМАЛИК ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ОЛМАЛИК ШАХРИ'
  //     },
  //     {
  //       id: 105,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 129,
  //       LOCAL_REGION_NAME: 'АНГРЕН ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'АНГРЕН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'АНГРЕН ШАХРИ'
  //     },
  //     {
  //       id: 106,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 130,
  //       LOCAL_REGION_NAME: 'БЕКОБОД ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БЕКОБОД ШАХРИ',
  //       LOCAL_REGION_NAMER: 'БЕКОБОД ШАХРИ'
  //     },
  //     {
  //       id: 107,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 131,
  //       LOCAL_REGION_NAME: 'ЧИРЧИК ШАХРИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЧИРЧИК ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ЧИРЧИК ШАХРИ'
  //     },
  //     {
  //       id: 108,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 132,
  //       LOCAL_REGION_NAME: 'ОККУРГОН ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОККУРГОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОККУРГОН ТУМАНИ'
  //     },
  //     {
  //       id: 109,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 133,
  //       LOCAL_REGION_NAME: 'ОХАНГАРОН ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОХАНГАРОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОХАНГАРОН ТУМАНИ'
  //     },
  //     {
  //       id: 110,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 134,
  //       LOCAL_REGION_NAME: 'БУСТОНЛИК ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУСТОНЛИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУСТОНЛИК ТУМАНИ'
  //     },
  //     {
  //       id: 111,
  //       REGION: 27,
  //       REGION_NAME: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION: 135,
  //       LOCAL_REGION_NAME: 'БУКА ТУМАНИ',
  //       REGION_PLACE: 12,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ТОШКЕНТ ВИЛОЯТИ',
  //       REGION_NAMER: 'ТОШКЕНТ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУКА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУКА ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 30,
  //   REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 1,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 157,
  //       LOCAL_REGION_NAME: 'КУВА ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУВА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУВА ТУМАНИ'
  //     },
  //     {
  //       id: 3,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 163,
  //       LOCAL_REGION_NAME: 'УЗБЕКИСТОН ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЗБЕКИСТОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЗБЕКИСТОН ТУМАНИ'
  //     },
  //     {
  //       id: 4,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 166,
  //       LOCAL_REGION_NAME: 'ФУРКАТ ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ФУРКАТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ФУРКАТ ТУМАНИ'
  //     },
  //     {
  //       id: 2,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 160,
  //       LOCAL_REGION_NAME: 'РИШТОН ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'РИШТОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'РИШТОН ТУМАНИ'
  //     },
  //     {
  //       id: 204,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 167,
  //       LOCAL_REGION_NAME: 'КИРГУЛИЙСКИЙ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КИРГУЛИЙСКИЙ',
  //       LOCAL_REGION_NAMER: 'КИРГУЛИЙСКИЙ'
  //     },
  //     {
  //       id: 200,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 161,
  //       LOCAL_REGION_NAME: 'СУХ ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'СУХ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'СУХ ТУМАНИ'
  //     },
  //     {
  //       id: 201,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 162,
  //       LOCAL_REGION_NAME: 'ТОШЛОК ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТОШЛОК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТОШЛОК ТУМАНИ'
  //     },
  //     {
  //       id: 202,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 164,
  //       LOCAL_REGION_NAME: 'УЧКУПРИК ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УЧКУПРИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УЧКУПРИК ТУМАНИ'
  //     },
  //     {
  //       id: 203,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 165,
  //       LOCAL_REGION_NAME: 'ФАРГОНА ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ФАРГОНА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ФАРГОНА ТУМАНИ'
  //     },
  //     {
  //       id: 124,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 148,
  //       LOCAL_REGION_NAME: 'КУКОН ШАХРИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУКОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'КУКОН ШАХРИ'
  //     },
  //     {
  //       id: 125,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 149,
  //       LOCAL_REGION_NAME: 'МАРГИЛОН ШАХРИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'МАРГИЛОН ШАХРИ',
  //       LOCAL_REGION_NAMER: 'МАРГИЛОН ШАХРИ'
  //     },
  //     {
  //       id: 126,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 150,
  //       LOCAL_REGION_NAME: 'ФАРГОНА ШАХРИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ФАРГОНА ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ФАРГОНА ШАХРИ'
  //     },
  //     {
  //       id: 127,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 151,
  //       LOCAL_REGION_NAME: 'КУВАСОЙ ШАХРИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУВАСОЙ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'КУВАСОЙ ШАХРИ'
  //     },
  //     {
  //       id: 128,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 152,
  //       LOCAL_REGION_NAME: 'БЕШАРИК ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БЕШАРИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БЕШАРИК ТУМАНИ'
  //     },
  //     {
  //       id: 129,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 153,
  //       LOCAL_REGION_NAME: 'БОГДОД ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БОГДОД ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БОГДОД ТУМАНИ'
  //     },
  //     {
  //       id: 130,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 154,
  //       LOCAL_REGION_NAME: 'БУВАЙДА ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БУВАЙДА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУВАЙДА ТУМАНИ'
  //     },
  //     {
  //       id: 131,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 155,
  //       LOCAL_REGION_NAME: 'ДАНГАРА ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ДАНГАРА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ДАНГАРА ТУМАНИ'
  //     },
  //     {
  //       id: 132,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 156,
  //       LOCAL_REGION_NAME: 'ЁЗЁВОН ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЁЗЁВОН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЁЗЁВОН ТУМАНИ'
  //     },
  //     {
  //       id: 198,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 158,
  //       LOCAL_REGION_NAME: 'ОЛТИАРИК ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ОЛТИАРИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ОЛТИАРИК ТУМАНИ'
  //     },
  //     {
  //       id: 199,
  //       REGION: 30,
  //       REGION_NAME: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION: 159,
  //       LOCAL_REGION_NAME: 'КУШТЕПА ТУМАНИ',
  //       REGION_PLACE: 13,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ФАРГОНА ВИЛОЯТИ',
  //       REGION_NAMER: 'ФАРГОНА ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУШТЕПА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУШТЕПА ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 33,
  //   REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 5,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 168,
  //       LOCAL_REGION_NAME: 'УРГАНЧ ШАХРИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УРГАНЧ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'УРГАНЧ ШАХРИ'
  //     },
  //     {
  //       id: 6,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 171,
  //       LOCAL_REGION_NAME: 'ГУРЛАН ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ГУРЛАН ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ГУРЛАН ТУМАНИ'
  //     },
  //     {
  //       id: 7,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 174,
  //       LOCAL_REGION_NAME: 'ХОНКА ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХОНКА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХОНКА ТУМАНИ'
  //     },
  //     {
  //       id: 8,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 177,
  //       LOCAL_REGION_NAME: 'ШОВОТ ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ШОВОТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШОВОТ ТУМАНИ'
  //     },
  //     {
  //       id: 19,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 212,
  //       LOCAL_REGION_NAME: 'ХИВА ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХИВА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХИВА ТУМАНИ'
  //     },
  //     {
  //       id: 212,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 179,
  //       LOCAL_REGION_NAME: 'ЯНГИБОЗОР ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИБОЗОР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИБОЗОР ТУМАНИ'
  //     },
  //     {
  //       id: 206,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 170,
  //       LOCAL_REGION_NAME: 'ПИТНАК ШАХРИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ПИТНАК ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ПИТНАК ШАХРИ'
  //     },
  //     {
  //       id: 207,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 172,
  //       LOCAL_REGION_NAME: 'БОГОТ ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'БОГОТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БОГОТ ТУМАНИ'
  //     },
  //     {
  //       id: 208,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 173,
  //       LOCAL_REGION_NAME: 'ХАЗОРАСП ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХАЗОРАСП ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХАЗОРАСП ТУМАНИ'
  //     },
  //     {
  //       id: 209,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 175,
  //       LOCAL_REGION_NAME: 'ЯНГИАРИК ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ЯНГИАРИК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЯНГИАРИК ТУМАНИ'
  //     },
  //     {
  //       id: 210,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 176,
  //       LOCAL_REGION_NAME: 'КУШКУПИР ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'КУШКУПИР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУШКУПИР ТУМАНИ'
  //     },
  //     {
  //       id: 211,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 178,
  //       LOCAL_REGION_NAME: 'УРГАНЧ ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'УРГАНЧ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'УРГАНЧ ТУМАНИ'
  //     },
  //     {
  //       id: 205,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 169,
  //       LOCAL_REGION_NAME: 'ХИВА ШАХРИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ХИВА ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ХИВА ШАХРИ'
  //     },
  //     {
  //       id: 135,
  //       REGION: 33,
  //       REGION_NAME: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION: 226,
  //       LOCAL_REGION_NAME: 'ТУПРОККАЛЪА ТУМАНИ',
  //       REGION_PLACE: 14,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'ХОРАЗМ ВИЛОЯТИ',
  //       REGION_NAMER: 'ХОРАЗМ ВИЛОЯТИ',
  //       LOCAL_REGION_NAMEU: 'ТУПРОККАЛЪА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТУПРОККАЛЪА ТУМАНИ'
  //     }
  //   ]
  // },
  // {
  //   REGION: 35,
  //   REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //   SUB_REGIONS: [
  //     {
  //       id: 14,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 196,
  //       LOCAL_REGION_NAME: 'МАНГИТСКИЙ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'МАНГИТСКИЙ',
  //       LOCAL_REGION_NAMER: 'МАНГИТСКИЙ'
  //     },
  //     {
  //       id: 13,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 193,
  //       LOCAL_REGION_NAME: 'КОРАУЗАК ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'КОРАУЗАК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОРАУЗАК ТУМАНИ'
  //     },
  //     {
  //       id: 12,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 190,
  //       LOCAL_REGION_NAME: 'ЧИМБОЙ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ЧИМБОЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЧИМБОЙ ТУМАНИ'
  //     },
  //     {
  //       id: 11,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 187,
  //       LOCAL_REGION_NAME: 'ТАХТАКУПИР ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ТАХТАКУПИР ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТАХТАКУПИР ТУМАНИ'
  //     },
  //     {
  //       id: 9,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 182,
  //       LOCAL_REGION_NAME: 'КЕГЕЙЛИ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'КЕГЕЙЛИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КЕГЕЙЛИ ТУМАНИ'
  //     },
  //     {
  //       id: 10,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 184,
  //       LOCAL_REGION_NAME: 'КУНГИРОТ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'КУНГИРОТ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КУНГИРОТ ТУМАНИ'
  //     },
  //     {
  //       id: 225,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 216,
  //       LOCAL_REGION_NAME: 'НУКУС ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'НУКУС ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'НУКУС ТУМАНИ'
  //     },
  //     {
  //       id: 226,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 222,
  //       LOCAL_REGION_NAME: 'ТАХИАТОШ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ТАХИАТОШ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТАХИАТОШ ТУМАНИ'
  //     },
  //     {
  //       id: 224,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 209,
  //       LOCAL_REGION_NAME: 'АМУДАРЁ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'АМУДАРЁ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'АМУДАРЁ ТУМАНИ'
  //     },
  //     {
  //       id: 223,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 195,
  //       LOCAL_REGION_NAME: 'БОЗАТАУССКИЙ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'БОЗАТАУССКИЙ',
  //       LOCAL_REGION_NAMER: 'БОЗАТАУССКИЙ'
  //     },
  //     {
  //       id: 222,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 194,
  //       LOCAL_REGION_NAME: 'ЭЛЛИККАЛА ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ЭЛЛИККАЛА ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ЭЛЛИККАЛА ТУМАНИ'
  //     },
  //     {
  //       id: 221,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 192,
  //       LOCAL_REGION_NAME: 'КОНЛИКУЛ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'КОНЛИКУЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'КОНЛИКУЛ ТУМАНИ'
  //     },
  //     {
  //       id: 220,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 191,
  //       LOCAL_REGION_NAME: 'БЕРУНИЙ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'БЕРУНИЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БЕРУНИЙ ТУМАНИ'
  //     },
  //     {
  //       id: 219,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 189,
  //       LOCAL_REGION_NAME: 'ХУЖАЙЛИ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ХУЖАЙЛИ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ХУЖАЙЛИ ТУМАНИ'
  //     },
  //     {
  //       id: 218,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 188,
  //       LOCAL_REGION_NAME: 'ТУРТКУЛ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ТУРТКУЛ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ТУРТКУЛ ТУМАНИ'
  //     },
  //     {
  //       id: 217,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 186,
  //       LOCAL_REGION_NAME: 'АКМАНГИТСКИЙ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'АКМАНГИТСКИЙ',
  //       LOCAL_REGION_NAMER: 'АКМАНГИТСКИЙ'
  //     },
  //     {
  //       id: 216,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 185,
  //       LOCAL_REGION_NAME: 'МУЙНОК ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'МУЙНОК ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'МУЙНОК ТУМАНИ'
  //     },
  //     {
  //       id: 215,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 183,
  //       LOCAL_REGION_NAME: 'ШУМАНАЙ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ШУМАНАЙ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'ШУМАНАЙ ТУМАНИ'
  //     },
  //     {
  //       id: 214,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 181,
  //       LOCAL_REGION_NAME: 'ТАХИАТОШ ШАХРИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'ТАХИАТОШ ШАХРИ',
  //       LOCAL_REGION_NAMER: 'ТАХИАТОШ ШАХРИ'
  //     },
  //     {
  //       id: 213,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 180,
  //       LOCAL_REGION_NAME: 'НУКУС ШАХРИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'НУКУС ШАХРИ',
  //       LOCAL_REGION_NAMER: 'НУКУС ШАХРИ'
  //     },
  //     {
  //       id: 133,
  //       REGION: 35,
  //       REGION_NAME: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION: 225,
  //       LOCAL_REGION_NAME: 'БУЗАТОВ ТУМАНИ',
  //       REGION_PLACE: 1,
  //       LOCAL_REGION_PLACE: '',
  //       REGION_NAMEU: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       REGION_NAMER: 'КОРАКАЛПОГИСТОН РЕСПУБЛИКАСИ',
  //       LOCAL_REGION_NAMEU: 'БУЗАТОВ ТУМАНИ',
  //       LOCAL_REGION_NAMER: 'БУЗАТОВ ТУМАНИ'
  //     }
  //   ]
  // }
]


const regionSelect = document.querySelector("#region__select");
const citySelect = document.querySelector("#city__select");
const fullAddressInput = document.querySelector("#address")


fullAddressInput.value = regions[0].REGION_NAME + " " + regions[0].SUB_REGIONS[0].LOCAL_REGION_NAME

regions.forEach((region) => {
  const option = document.createElement("option");
  option.innerText = region.REGION_NAME;
  option.value = region.REGION;
  regionSelect.appendChild(option);
});

generateCities(regions[0].REGION);


regionSelect.addEventListener("change", function (e) {
  const regionId = e.target.value;
  const region = regions.find((region) => region.REGION == regionId);
  fullAddressInput.value = region.REGION_NAME + " " + region.SUB_REGIONS[0].LOCAL_REGION_NAME
  
  generateCities(regionId);
});

citySelect.addEventListener("change", function (e) {
  const cityId = e.target.value
  const region = regions.find(region => region.REGION == regionSelect.value)


  if(!region) throw Error("Region not found")

  const city = region.SUB_REGIONS.find(city => city.id == cityId)

  if(!city) throw Error("City not found")
  
  fullAddressInput.value = region.REGION_NAME + " " + city.LOCAL_REGION_NAME
  
});

function generateCities(regionId) {
  const region = regions.find((region) => region.REGION == regionId);
  citySelect.innerHTML = "";
  if (!region) {
    return;
  }

  region.SUB_REGIONS.forEach((subRegion) => {
    const option = document.createElement("option");
    citySelect.disabled = false;
    option.innerText = subRegion.LOCAL_REGION_NAME;
    option.value = subRegion.id;
    citySelect.appendChild(option);
  });
}
